import { toast } from "sonner";

type ToastArgs = Parameters<typeof toast>;

export function safeToast(...args: ToastArgs) {
  return toast(...args);
}

safeToast.success = toast.success.bind(toast);
safeToast.info = toast.info.bind(toast);
safeToast.loading = toast.loading.bind(toast);
safeToast.dismiss = toast.dismiss.bind(toast);
safeToast.promise = toast.promise.bind(toast);
safeToast.custom = toast.custom.bind(toast);
safeToast.message = toast.message.bind(toast);
